import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Home from './pages/HomePage';
import Login from './pages/LoginPage';
import { AuthProvider } from './services/authentication/authContext';
import ProtectedRoute from './services/protected route/ProtectedRoute ';
import CalculateBudgetHours from './pages/CalculateBudgetHoursPage';
import ChangePassword from './pages/ChangePasswordPage';
import ForgotPassword from './pages/ForgotPasswordPage';
import VerifyOtp from './pages/VerifyOtpPage';
import ResetPassword from './pages/ResetPasswordPage';
import './css/Dialog.css';


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => !!localStorage.getItem('accessToken'));
  const [passwordChanged, setPasswordChanged] = useState(() => localStorage.getItem('passwordChanged') === 'true');

  const handleLogin = (status) => {
    setIsLoggedIn(status);

    const isPasswordChanged = localStorage.getItem('passwordChanged');
    setPasswordChanged(isPasswordChanged === "true");
  };

  return (
    <AuthProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }} basename="/workmate">
        <div className="App">

          <Routes>
            <Route
              path="/"
              element={isLoggedIn ? <Navigate to="/home" /> : <Login onLogin={handleLogin} />}
            />
            <Route
              path="/change-password"
              element={isLoggedIn ? <ChangePassword /> : <Navigate to="/login" />}
            />
            <Route
              path="/home/*"
              // element={isLoggedIn ? <Home /> : <div></div>} 
              element={isLoggedIn ? (localStorage.getItem("passwordChanged") === "true" ? <Home /> : <Navigate to="/change-password" />) : <div></div>}
            />
            <Route
              path="/login"
              element={<ProtectedRoute element={<Login onLogin={handleLogin} />} redirectTo="/home" />}
            />
            <Route path="/calculate-budget-hours" element={<CalculateBudgetHours />} />

            {/* Forgot Password public routes — no auth required */}
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/verify-otp" element={<VerifyOtp />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes>

        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
